import axios from "axios";
import Cookies from "js-cookie";

const instance = axios.create({
  baseURL: document.querySelector("#CiprianiPath").value,
  timeout: 200000,
  headers: {
    // 'X-Auth-Token': 'f2b6637ddf355a476918940289c0be016a4fe99e3b69c83d',
    "Content-Type": "application/json"
  },
  json: true
});

// set fresh header before each request
instance.interceptors.request.use(
  config => {
    // NProgress.inc();
    const token = Cookies.get("loginToken");
    // console.log("COOKIE:::", token);
    // set auth token if it exists
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = "";
    }
    return config;
  },
  err => Promise.reject(err)
);

instance.interceptors.response.use(
  response =>
    // NProgress.done();
    // console.log("RESPONSE:::", response);
    response,
  err => {
    console.log("RESPONSE ERROR::", err);
    // "Unauthorized"
    // alert(JSON.stringify(err));
    /*if (err && err.response.status === 401) {
      Cookies.remove("loginToken");
      router.push("/login");
    }*/
    return err;
  }
);

export const api = instance;
